import { Box, Divider, Flex, Icon, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaMapMarker } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { CounterpartyDto } from "../../../../autogen/bff-api";
import { ContractState } from "../../../../common/redux/reducers/contractReducer";
import { useOrganizationProfileUrls } from "../../../organizations/useOrganizationProfileUrls";
import { ProfileImageRounded } from "../../../../common/persons/ProfileImageRounded";
import { getCounterpartyAsSeen } from "../../typeguards";
import { getCounterpartyCountry, getCounterpartyName } from "../../view-all/ContractRow";
import { CountryName } from "../../../../common/countries/CountryName";

interface Props {
  data: ContractState["contract"];
}

export const Counterparty = ({ data }: Props) => {
  const { t } = useTranslation();

  const counterparty = getCounterpartyAsSeen(data);

  return (
    <Box padding="15px" w="100%">
      <Text as="h2" fontWeight={"bold"} fontSize="sm" color="smMuted">
        {t("Counterparty")}
      </Text>
      <Divider marginTop={"5px"} marginBottom={"5px"} />
      {counterparty ? (
        <CounterpartyProfile counterparty={counterparty} />
      ) : (
        <Text fontStyle={"italic"}>{t("Not provided")}</Text>
      )}
    </Box>
  );
};

const CounterpartyProfile = ({ counterparty }: { counterparty: CounterpartyDto }) => {
  const navigate = useNavigate();
  const profileUrls = useOrganizationProfileUrls();
  const name = getCounterpartyName(counterparty);
  const country = getCounterpartyCountry(counterparty);

  const handleOrganizationClick = () => {
    if (counterparty.organization) {
      navigate(profileUrls.go(counterparty.organization.id));
    } else if (counterparty.organizationEntry) {
      navigate(profileUrls.goToEntry(counterparty.organizationEntry.id));
    }
  };

  return (
    <>
      <Flex mt="13px" onClick={handleOrganizationClick} cursor="pointer" p="2">
        <Flex>
          <ProfileImageRounded name={name} width="30px" backgroundColor="blue.500" fontSize={"xs"} />
        </Flex>
        <Flex justifyContent={"center"} mt="-1px" ml="7px">
          <Text fontSize={"xl"} fontWeight="semibold">
            {name}
          </Text>
        </Flex>
      </Flex>
      <Flex mt="15px">
        <Icon as={FaMapMarker} ml="6px" w="15px" h="15px" color={"smMuted"} />
        <Text fontSize={"sm"} color="smMuted" ml="17px" mt="-3px">
          <CountryName country={country} />
        </Text>
      </Flex>
    </>
  );
};
